import React from "react";
import { FaCaretRight } from "react-icons/fa6";
import { FaNodeJs, FaReact } from "react-icons/fa";
import { TbSql } from "react-icons/tb";
import { BiLogoTailwindCss } from "react-icons/bi";
import { VscAzure } from "react-icons/vsc";
import { FaNode } from "react-icons/fa";
import { useNavigate } from "react-router";
import { SiSocketdotio } from "react-icons/si";

function Pomodoro() {
    const navigate = useNavigate();
    return (
        <div className="flex flex-col p-3">
            <div
                onClick={() => {
                    navigate("/");
                }}
                className="flex items-center opacity-60 text-sm transition-all hover:cursor-pointer hover:opacity-100 font-sourcecodepro"
            >
                &larr; back
            </div>
            <div className="text-3xl font-bold">PomoRelax: Pomodoro Timer</div>
            <div className="flex flex-col gap-8">
                <div className="text-xl font-light italic">
                    A simple pomodoro timer that uses the pexels api for the
                    background image.
                </div>
                <div className="mx-auto w-4/5 md:w-full">
                    <img className="border-4" src="/Images/pomodoro.gif"></img>
                    <div className="italic font-extralight text-center">
                        PomoRelax
                    </div>
                </div>
            </div>

            <div className="text-2xl">Goal For Project</div>
            <div>
                The goal for this project is to make a simple React pomodoro app
                to practice React state hooks and API integration with the front
                end. I want it to be easily extendable to add other widgets and
                apps to be an all-in-one productivty app.
            </div>
            <div className="mx-auto w-4/5 md:w-full">
                <img className="border-4" src="/Images/pexels.jpg"></img>
                <div className="italic font-extralight text-center">
                    Example Pexels Image
                </div>
            </div>
            <div className="text-2xl">Technology</div>
            <div className="flex flex-col gap-8">
                <div>
                    For this project i'm using React and Tailwind. As i extend
                    to more features i will most likely end up using a wider
                    technology stack.
                </div>
                <div className="flex flex-row text-3xl lg:text-8xl mx-auto justify-around w-full">
                    <div className="flex flex-col items-center">
                        <BiLogoTailwindCss />
                        <div className="text-xl text-center">Tailwind</div>
                    </div>
                    <div className="flex flex-col items-center">
                        <FaReact />
                        <div className="text-xl text-center">React</div>
                    </div>
                    <div className="flex flex-col items-center">
                        <FaNodeJs />
                        <div className="text-xl text-center">NodeJS</div>
                    </div>
                    <div className="flex flex-col items-center">
                        <TbSql />
                        <div className="text-xl text-center">MSSQL</div>
                    </div>
                </div>

                <div>
                    I chose React as it is great for one page applications which
                    this project will most likely stay as i add more widgets. I
                    selected tailwind due to the ease of adding responsive web
                    design to the project and my familiarity of using it.
                </div>
            </div>
            <div className="text-2xl mt-4">Planned Features</div>
            <div className="flex flex-col gap-8">
                <div className="mx-auto w-4/5 md:w-full">
                    <img
                        className="border-4 mx-auto"
                        src="/Images/plan.png"
                    ></img>
                    <div className="italic font-extralight text-center">
                        Planned Features
                    </div>
                </div>
                <div>
                    Although the background images currently look great, i think
                    having looping animated backgrounds or atleast the option to
                    toggle between themes and static vs moving background could
                    be a good feature.
                    <div className="mt-2 font-bold">
                        Other Potential Features:
                    </div>
                    <div className="ml-3">
                        <div>- Light/Dark Mode</div>
                        <div>
                            - Sound Effects with mute option (Sounds added, no
                            mute button)
                        </div>
                        <div>- Inspirational Quotes</div>
                        <div>- Completed Tasks/Deleted Tasks</div>
                        <div>
                            - Collaborative Pomodoro with a friend using socket
                            io
                        </div>
                    </div>
                </div>
            </div>

            <div className="text-2xl mt-4">Post-Mortem</div>
            <div className="flex flex-col gap-2">
                <div className="font-bold">What I learned</div>
                <div>
                    Although this project is still undergoing changes and new
                    features, so far i have learnt about how to implement timers
                    in a browser where users are swapping windows and ensuring
                    the timer stays the correct time due to resource allocation
                    and intervals running slower when tabbed. I overcame this by
                    using date and the difference between when the timer started
                    and the current time. I also added google OAuth login so
                    users can access their todos from different machines.
                </div>
                <div className="mx-auto w-4/5 md:w-full">
                    <img
                        className="border-4 mx-auto"
                        src="/Images/wip.jpg"
                    ></img>
                    <div className="italic font-extralight text-center">
                        Currently Busy Working....
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Pomodoro;
